// @ts-expect-error not migrated to TS yet
import { getStaticListLimitReached } from 'EmailData/selectors/emailLimitsSelectors';
import { getHasIlsListsWriteScope, getHasListsReadScope, getHasListsWriteScope // @ts-expect-error not migrated to TS yet
} from 'EmailData/selectors/emailRecipientsSelectors';
// @ts-expect-error not migrated to TS yet
import { getCanSeeAdditionalMoreToolsContent } from 'EmailData/selectors/user';
import { useSelector } from 'react-redux';
import MoreToolsButton from './MoreToolsButton';
import { jsx as _jsx } from "react/jsx-runtime";
function MoreToolsButtonContainer(props) {
  const hasListsWriteScope = useSelector(state => getHasListsWriteScope(() => state));
  const hasListsViewScope = useSelector(state => getHasListsReadScope(() => state));
  const hasIlsListsWriteScope = useSelector(state => getHasIlsListsWriteScope(() => state));
  const staticListLimitReached = useSelector(getStaticListLimitReached);
  const canSeeAdditionalMoreToolsContent = useSelector(getCanSeeAdditionalMoreToolsContent);
  return /*#__PURE__*/_jsx(MoreToolsButton, Object.assign({
    canSeeAdditionalMoreToolsContent: canSeeAdditionalMoreToolsContent,
    hasIlsListsWriteScope: hasIlsListsWriteScope,
    hasListsViewScope: hasListsViewScope,
    hasListsWriteScope: hasListsWriteScope,
    staticListLimitReached: staticListLimitReached
  }, props));
}
export default MoreToolsButtonContainer;